import React, { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import mainStyle from "../../style/Main.module.css";
import { GoFilter } from "react-icons/go";
import SearchComponent from "../../components/ui/input/Search/Search";
import Button from "../../components/ui/buttons/Button";
import formatDate from "../../components/ui/dateFormat";
import Select from "react-select";
import PaginationComponent from "../../components/ui/Pagination/PaginationComponent";
import NoDataFound from "../../components/ui/NoDataFound/NoDataFound";
import PageLoader from "../../components/ui/Loader/PageLoader";
import { actionLogs, categoryLog } from "../../config/selectOptions";
import { useCompanyFilter } from "../../hooks/UseFilter";
import { useLogList } from "../../hooks/useLogs";
import Clearlog from "./ClearLogs";
import ViewSelectedLog from "./ViewSelectedLog";
import { FaRegEye } from "react-icons/fa";
import RemoveConfirmation from "../../components/ui/Warning/Remove";
import { formatTimeWithoutSeconds } from "../../utils/format";

const LogsPage = () => {
  const perPage = 10;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [showFilter, setShowFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectedLogs, setSelectedLogs] = useState([]);
  const [company, setCompany] = useState("");
  const [search, setSearch] = useState("");
  const [showSelectedLogs, setShowSelectedLogs] = useState(false);
  const [showClearPopup, setShowClearPopup] = useState(false);
  const [logsId, setLogsId] = useState("");
  const [datas, setDatas] = useState("");
  const [action, setAction] = useState("");
  const [category, setCategory] = useState("");
  const [deleteLog, setDeleteLog] = useState(false);
  const companyFilter = useCompanyFilter();
  const {
    logsData: viewLogs,
    totalCount: totalEmployeeCount,
    loading: isLoading,
    refresh: refreshEmployeeList, // Make sure your useEmployeeList hook provides this
  } = useLogList(company, currentPage, perPage, action, search, category);
  const toggleFilter = () => setShowFilter((prev) => !prev);

  const handleAllCheckboxChange = () => {
    if (isAllChecked) {
      setSelectedLogs([]);
    } else {
      setSelectedLogs(viewLogs.map((employee) => employee.id));
    }
    setIsAllChecked(!isAllChecked);
  };

  const handleCheckboxChange = (id) => {
    setSelectedLogs((prevState) => {
      let newSelected;
      if (prevState.includes(id)) {
        newSelected = prevState.filter((empId) => empId !== id);
      } else {
        newSelected = [...prevState, id];
      }

      //ViewGroupData
      setIsAllChecked(newSelected.length === viewLogs.length);

      return newSelected;
    });
  };

  const currentPageNo = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const handleSearch = (term) => {
    if (term !== search) {
      setSearch(term);
      setCurrentPage(1);
    }
  };

  const handleCompanyFilter = (option) => {
    if (option?.value !== company) {
      setCompany(option.value);
      setCurrentPage(1);
    }
  };
  const handleDeleteSucess = () => {
    refreshEmployeeList();
    setSelectedLogs([]);
    setIsAllChecked(false);
  };

  const handleClearSucess = () => {
    refreshEmployeeList();
  };

  const handleDelete = () => {
    const payload = {
      id_list: selectedLogs,
    };
    setDatas(payload);
    setDeleteLog(true);
  };

  const handleFilterChange = (selectedOption) => {
    const newStatus = selectedOption ? selectedOption.value : "";
    if (newStatus !== category) {
      setCategory(newStatus);
      setCurrentPage(1);
    }
  };
  const handleActionChange = (selectedOption) => {
    const newStatus = selectedOption ? selectedOption.value : "";
    if (newStatus !== action) {
      setAction(newStatus);
      setCurrentPage(1);
    }
  };

  const handleClickView = (id) => {
    // console.log(id);
    setLogsId(id);
    setShowSelectedLogs(true);
  };

  return (
    <>
      <MainLayout>
        <div className={mainStyle.mainPageHeader}>
          {selectedLogs.length === 0 ? (
            <>
              <div>
                <p>Logs</p>
              </div>
              <div className={mainStyle.mainPageButtons}>
                <SearchComponent onSearch={handleSearch} />
                <Button onClick={() => setShowClearPopup(true)}>Clear</Button>
                <button
                  className={mainStyle.FilterButton}
                  onClick={toggleFilter}
                >
                  <GoFilter /> Filter
                </button>
              </div>
            </>
          ) : (
            <>
              <div></div>
              <div className={mainStyle.mainPageButtons}>
                <Button variant="danger" onClick={handleDelete}>
                  Delete
                </Button>
              </div>
            </>
          )}
        </div>

        {showFilter && (
          <div className={mainStyle.mainPageFilter}>
            <div className={mainStyle.mainPageFilterSub}>
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Company</span>
                <Select
                  className={mainStyle.pagesFilter}
                  placeholder="Select Company"
                  options={companyFilter}
                  onChange={handleCompanyFilter}
                  value={companyFilter.find(
                    (option) => option.value === company
                  )}
                />
              </div>
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Status</span>
                <Select
                  className={mainStyle.pagesFilter}
                  placeholder="Action"
                  options={actionLogs}
                  onChange={handleActionChange}
                  value={actionLogs.find((option) => option.value === action)}
                />
              </div>
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Category</span>
                <Select
                  className={mainStyle.pagesFilter}
                  placeholder="Category"
                  options={categoryLog}
                  onChange={handleFilterChange}
                  value={categoryLog.find(
                    (option) => option.value === category
                  )}
                />
              </div>
            </div>
          </div>
        )}

        <div
          className={mainStyle.mainContentView}
          style={{ height: showFilter ? "82%" : "92%" }}
        >
          {isLoading ? (
            <PageLoader />
          ) : (
            <div className={mainStyle.mainContentViewsb}>
              {viewLogs && viewLogs.length > 0 ? (
                <div className={mainStyle.mainTableDiv}>
                  <table className={mainStyle.mainTable}>
                    <thead className={mainStyle.mainTableHead}>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            checked={isAllChecked}
                            onChange={handleAllCheckboxChange}
                          />
                        </th>
                        <th>Edited Person </th>
                        <th>Company</th>
                        <th>Action</th>
                        <th>Category</th>
                        <th>Edited Date & Time</th>
                        <th>View</th>
                      </tr>
                    </thead>

                    <tbody className={mainStyle.mainTableBody}>
                      {viewLogs.map((emp, index) => (
                        <tr key={emp.id || index}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedLogs.includes(emp.id)}
                              onChange={() => handleCheckboxChange(emp.id)}
                            />
                          </td>
                          <td>
                            <div className={mainStyle.tableImgViewdiv}>
                              <div>
                                {/* <div className={mainStyle.tableImgView}>
                                  <img
                                    src={`${apiUrl}${emp.emp_pic}`}
                                    alt="img"
                                  />
                                </div> */}
                              </div>
                              <div className={mainStyle.tableImgViewContent}>
                                <div
                                  className={mainStyle.tableImgViewContentName}
                                >
                                  {`${emp.edited_name} `}
                                </div>
                                {/* <div className={mainStyle.tableTextOverFlow}>
                                  {emp.channel_topic}
                                </div> */}
                              </div>
                            </div>
                          </td>
                          <td>
                            <img
                              src={`${apiUrl}${emp.company_logo}`}
                              alt="company"
                              className={mainStyle.companyLogo}
                            />
                          </td>
                          <td>{emp.action}</td>
                          <td>{emp.category}</td>
                          <td>
                            {formatDate(emp.date)} &
                            {formatTimeWithoutSeconds(emp.time)}
                          </td>
                          <td>
                            <FaRegEye
                              size={18}
                              style={{ color: "#3b82f6" }}
                              onClick={() => handleClickView(emp.id)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <NoDataFound
                  title="No Logs Found"
                  description="No logs found. You haven't performed any actions yet, so there's nothing to display."
                  // buttonText="Add New Channel"
                  // onButtonClick={addChannelPage}
                />
              )}

              <div>
                {!isLoading && totalEmployeeCount > perPage && (
                  <PaginationComponent
                    pageCount={Math.ceil(totalEmployeeCount / perPage)}
                    onPageChange={currentPageNo}
                    forcePage={currentPage - 1}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        {/* Edit Modal */}
      </MainLayout>
      {showClearPopup && (
        <Clearlog
          close={() => setShowClearPopup(false)}
          updated={handleClearSucess}
        />
      )}
      {showSelectedLogs && (
        <ViewSelectedLog
          onClose={() => setShowSelectedLogs(false)}
          id={logsId}
        />
      )}
      {deleteLog && (
        <RemoveConfirmation
          onClose={() => setDeleteLog(false)}
          onSucess={handleDeleteSucess}
          datas={datas}
        />
      )}
    </>
  );
};

export default LogsPage;
